import config from 'config'
import CartItem from '@vue-storefront/core/modules/cart/types/CartItem'
import { filterCustomOptionsForProduct } from '@vue-storefront/core/modules/catalog/helpers/customOption'

const createCartItemForUpdate = (item: CartItem): CartItem => {
  const sku = item.parentSku && config.cart.setConfigurableProductOptions ? item.parentSku : item.sku
  let productOption = item.product_option

  if (productOption?.extension_attributes?.custom_options && item.custom_options) {
    productOption = {
      ...productOption,
      extension_attributes: {
        ...productOption.extension_attributes,
        custom_options: filterCustomOptionsForProduct(
          item.custom_options,
          productOption.extension_attributes.custom_options
        )
      }
    }
  }

  const cartItem = {
    ...((item && item.server_item_id) ? { item_id: item.server_item_id } : {}),
    ...((item && item.server_item_id) ? {} : { sku }), // if server_item_id is set omit sku (otherwise Magento adds to quantity)
    qty: item.qty,
    product_option: productOption
  } as any as CartItem

  return cartItem
}

export default createCartItemForUpdate
